module.exports = __webpack_public_path__ + "img/celebrate-category-icon.fa2b910b.svg";